import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from '../../../../styles/icons/logos/miller-lite.module.scss';

import yahooLogoEn from '../../../../img/nfl/yahoo-sports-en.png';
import yahooLogoFr from '../../../../img/nfl/yahoo-sports-fr.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function YahooSports({ className }) {
    const intl = useIntl();
    const { locale } = intl || {};
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <img
                src={locale === 'fr' ? yahooLogoFr : yahooLogoEn}
                className={styles.logo}
                alt={intl.formatMessage({
                    defaultMessage: 'Presented by Yahoo! Sports',
                    description: 'Logo alt',
                })}
            />
        </div>
    );
}

YahooSports.propTypes = propTypes;
YahooSports.defaultProps = defaultProps;

export default YahooSports;
